<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">خدمات الصيانة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">خدمات الصيانة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <!-- Category filter dropdown -->
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
          <div class="d-flex align-items-center gap-2">
            <label class="form-label mb-0 text-nowrap" style="font-size:14px;">تصفية حسب النوع:</label>
            <select
              v-model="filterCategory"
              class="form-select form-select-sm"
              style="min-width:160px;"
              @change="filterChanged"
            >
              <option value="">عرض الكل</option>
              <option
                v-for="(label, key) in categoryChoices"
                :key="key"
                :value="key"
              >{{ label }}</option>
            </select>
          </div>
          <div v-if="checkAccess('maintenance_issues_create')">
            <router-link to="/mIssues/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة خدمة
            </router-link>
          </div>
        </div>  
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header"><div class="card-title">خدمات الصيانة</div></div>
              <span v-if="filterCategory" class="badge bg-primary" style="font-size:12px;">
                {{ categoryChoices[filterCategory] }}
                <i class="bi bi-x ms-1" style="cursor:pointer;" @click="clearFilter"></i>
              </span>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الخدمة عربي</th>
                            <th>الخدمة انجليزي</th>
                            <th>نوع الخدمة</th>
                            <th>الحالة</th>
                            <th>اخر تحديث</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!rows.length">
                            <td colspan="7" class="text-center text-muted py-4">لا توجد خدمات</td>
                          </tr>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.name }}</td>
                            <td>{{ row.nameEn }}</td>
                            <td>
                              <span class="badge" :class="categoryBadgeClass(row.category)">
                                {{ categoryChoices[row.category] || row.category }}
                              </span>
                            </td>
                            <td>
                              <span class="badge" :class="row.isActive ? 'bg-success' : 'bg-secondary'">
                                {{ row.isActive ? 'نشط' : 'غير نشط' }}
                              </span>
                            </td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                            <td>
                              <router-link :to="`/mIssues/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('maintenance_issues_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('maintenance_issues_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'ServicesList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      filterCategory: this.$route.query.category || '',        
      categoryChoices: {},
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      const params = { page: this.currentPage };
      if (this.filterCategory) params.category = this.filterCategory;

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.filterCategory ? { category: this.filterCategory } : {}),
      }}).catch(() => {});

      this.$http.get('/api/admin/mIssues/list', { params }).then(({ data }) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        if (data.categoryChoices) this.categoryChoices = data.categoryChoices;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    
    filterChanged() {
      this.currentPage = 1;  
      this.getList();
    },

    clearFilter() {
      this.filterCategory = '';
      this.currentPage    = 1;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },

    categoryBadgeClass(cat) {
      return {
        all:    'bg-dark',
        normal: 'bg-info text-dark',
        fast:   'bg-warning text-dark',
        mosque: 'bg-success',
        global: 'bg-primary',
      }[cat] || 'bg-secondary';
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/mIssues/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>